import PluginResolver from 'resolvers/RTMResolvers/PluginResolver';
import { matchAnyDomain } from 'utils/email';

export default (() => {
  let pluginResolver;
  let isRegistered = false;

  /* async */ function resolvePlugin(pluginId, version, view) {
    const pluginPromise = pluginResolver.authorPluginGet(
      pluginId,
      version,
      view,
    );
    return pluginPromise;
  }

  /* async */ function getPlugin(pluginId, version, view) {
    if (!pluginId || !version) {
      return null;
    }

    return (
      resolvePlugin(pluginId, version, view)
    );
  }

  async function listPluginsByType(pluginType) {
    if (!pluginType) { return null; }
    return pluginResolver.authorPluginList(pluginType);
  }

  async function getOfficialPluginByName(name, type) {
    const plugins = await listPluginsByType(type);
    const plugin = plugins.find(({ name: pluginName, creator }) => (
      name.toLowerCase() === pluginName.toLowerCase()
      && matchAnyDomain(creator.primaryEmail, ['bronte.dev', 'pearson.com', 'grp.pearson.com'])
    ));

    if (!plugin) { return undefined; }

    return getPlugin(plugin.pluginId, plugin.latestVersion);
  }

  async function lockElementById(elementId) {
    return await pluginResolver.authorEditActive(elementId);
  }

  async function unlockElementById(elementId) {
    return await pluginResolver.authorEditRelease(elementId);
  }

  return {
    isRegistered: () => isRegistered,

    register: (connectionProvider) => {
      isRegistered = true;
      pluginResolver = new PluginResolver(connectionProvider);
    },

    getPlugin,
    getOfficialPluginByName,
    listPluginsByType,
    lockElementById,
    unlockElementById,
  };
})();
